import { Component, OnInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { NavigationService } from '../services/navigation.service';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  @ViewChild('objetivos', {static: true}) objetivos: ElementRef;
  @ViewChild('riesgos', {static: true}) riesgos: ElementRef;
  @ViewChild('consentimiento', {static: true}) consentimiento: ElementRef;
  @ViewChild('acciones', {static: true}) acciones: ElementRef;
  @ViewChild('directorio', {static: true}) directorio: ElementRef;

  constructor(
    private navigationService: NavigationService,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.setSectionOffset();

    this.navigationService.changed.subscribe(() => {
      this.setSectionOffset();
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setSectionOffset();
  }

  setSectionOffset(): void {
    const padding = 0;
    this.navigationService.offset.objetivos = this.objetivos.nativeElement.offsetTop - padding;
    this.navigationService.offset.riesgos = this.riesgos.nativeElement.offsetTop - padding;
    this.navigationService.offset.consentimiento = this.consentimiento.nativeElement.offsetTop - padding;
    this.navigationService.offset.acciones = this.acciones.nativeElement.offsetTop - padding;
    this.navigationService.offset.directorio = this.directorio.nativeElement.offsetTop - padding;
  }

  goTo(route: string): void {
    this.navigationService.scrollSection(route);
  }
}
